import { useCallback } from 'react';
import { SurveyOptions, SurveySender } from '../../types/surveys';
import {
  createBulletListFromDescription,
  enableNextButton,
  handleMenopausePage,
  handleTopMargin,
  handleVideoInjection,
  injectChoiceDescriptions,
} from '../../utils/onboarding/surveyDOMInjection';

export const useSurveyPageEffects = () => {
  const handleAfterRenderPage = useCallback((sender: SurveySender, options: SurveyOptions) => {
    const pageName = options.page.name;
    createBulletListFromDescription(pageName);
    handleVideoInjection(pageName);
    enableNextButton(options);
    handleMenopausePage(sender, options);
    handleTopMargin(sender.currentPageNo === 0);
    injectChoiceDescriptions(sender);
  }, []);

  return {
    handleAfterRenderPage,
  };
};
